import { render } from "./AdminBookingsBlock.vue?vue&type=template&id=6970888e"
import script from "./AdminBookingsBlock.vue?vue&type=script&lang=js"
export * from "./AdminBookingsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__